import { render, staticRenderFns } from "./VoucherPerformanceTab.vue?vue&type=template&id=c99829da&scoped=true"
import script from "./VoucherPerformanceTab.vue?vue&type=script&lang=js"
export * from "./VoucherPerformanceTab.vue?vue&type=script&lang=js"
import style0 from "./VoucherPerformanceTab.vue?vue&type=style&index=0&id=c99829da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99829da",
  null
  
)

export default component.exports